module.exports = __webpack_public_path__ + "img/office_exercise.f636d345.png";